// extracted by mini-css-extract-plugin
module.exports = {"form":"DashboardNew_form__22guu"};